import { Button } from "@/components/ui/button";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

type TechnicianEntry = {
	id?: string | number | null;
	name?: string | null;
};

type SelectTechnicianTableProps = {
	technicians?: TechnicianEntry[];
	loading?: boolean;
	buttonsText?: string;
	onSelect: (technician: TechnicianEntry) => void;
};

export function SelectTechnicianTable({
	technicians = [],
	loading = false,
	buttonsText = "Selecionar",
	onSelect,
}: SelectTechnicianTableProps) {
	return (
		<div className="overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead>Nome</TableHead>
						<TableHead className="text-right" />
					</TableRow>
				</TableHeader>
				<TableBody>
					{technicians.map((technician) => {
						const rowKey = technician.id ?? technician.name ?? "technician";
						return (
							<TableRow key={rowKey}>
								<TableCell>{technician.name ?? "-"}</TableCell>
								<TableCell className="text-right">
									<Button
										className="ml-2"
										size="sm"
										variant="secondary"
										disabled={loading}
										onClick={() => onSelect(technician)}
									>
										{buttonsText}
									</Button>
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</div>
	);
}
